module.exports = __webpack_public_path__ + "touxiang01.jpg?84729295fbac93d0c11b02934eb33068";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/touxiang01.jpg
// module id = 100
// module chunks = 0